import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
// import Loader from 'react-loader';
import Header from './Header';
import Dropdown from './Dropdown';
import Requirements from './Requirements';
import PrimaryStateAnswers from './PrimaryStateAnswers';
import ComparableStateAnswers from './ComparableStateAnswers';
import Instructions from './Instructions';

class DetailView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: [],
            jurisdictions: [],
            filteredStates: [],
            answers1: [],
            answers2: [],
            licenseTypeID: 1,
            activeIndex: 1,
            selectedUSState: null,
            selectedUSState2: null,
            activeMapLink: false,
            activeListLink: true,
            answerColumnOneLabel: null,
            answerColumnTwoLabel: null,
            openSubHeader: false
        }

        this.handleLicenseTypeChange = this.handleLicenseTypeChange.bind(this);
        this.toggleLicenseTypeColor = this.toggleLicenseTypeColor.bind(this);
    }

    componentWillMount() {
        let id = this.state.licenseTypeID;
        this.fetchQuestionsByLicenseType(id);
        this.fetchDetailQuestions(id);
    }

    fetchDetailQuestions(id)
    {
        fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/questions`)
        .then(function (response) {
            // console.log(response)
            return response.json();
        })
        .then((data) => {
            this.setState({
                questions: data.Questions,
                loaded: true
            })
        })
        .catch(function (error) {
            console.log(error);
        })
    }

    handleLicenseTypeChange(e) {
        // console.log(e.target.id);
        this.filterLicenseType(e);
        this.fetchDetailQuestions(e.target.id);
        this.toggleLicenseTypeColor(e.target.id);
        // this.highlightApplicableQuestions(this.state.selectedUSState);
        this.setState({
            selectedUSState: null,
            selectedUSState2: null,
            answers1: [],
            answers2: []
        })
    }
    render() {
        return (
            <div className="App">
                <div className="row header-wrapper">
                    <Header handleLicenseTypeChange={this.handleLicenseTypeChange} activeIndex={this.state.activeIndex} activeMapLink={this.state.activeMapLink} activeListLink={this.state.activeListLink} openSubHeader={this.state.openSubHeader} />
                </div>

                <div className="step-one">Step 3: Select a jurisdiction or jurisdictions to view and compare specific licensing requirements.
</div>
                <div className="state-comparison-container row">
                    <div>
                        <div>
                            <p className="jurisdiction-title">Primary Jurisdiction</p>
                        </div>
                        <Dropdown states={this.state.data} jurisdictions={this.state.jurisdictions} selectedUSState={this.state.selectedUSState} onSelectUSState={this.handleFirstSelectUSState} storeFirstDropdownLabel={this.storeFirstDropdownLabel} />
                    </div>
                    <div>
                        <div>
                            <p className="jurisdiction-title">Compare a Jurisdiction</p>
                        </div>
                        <Dropdown states={this.state.data} jurisdictions={this.state.jurisdictions} selectedUSState={this.state.selectedUSState2} onSelectUSState={this.handleSecondSelectUSState} storeSecondDropdownLabel={this.storeSecondDropdownLabel} />
                    </div>
                </div>
                <div className="lower-detail-view">
                    <div className="detail-view-questions">
                        <p className="requirements-title">Requirements</p>
                        <Requirements licenseTypeID={this.state.licenseTypeID} filteredStates={this.state.filteredStates} questions={this.state.questions} />
                        <div className="instructions-list-view"><Instructions/></div>
                    </div>
                    <div className="detail-view-answers">
                        <div className="state-answers">
                            {this.state.selectedUSState && <p>{this.state.answerColumnOneLabel}</p>}
                            <PrimaryStateAnswers answers={this.state.answers1} key={this.state.answers1.AnswerId} id={this.state.licenseTypeID} stateCode={this.state.selectedUSState} />
                        </div>
                        <div className="state-answers">
                            {this.state.selectedUSState2 && <p>{this.state.answerColumnTwoLabel}</p>}
                            <ComparableStateAnswers answers={this.state.answers2} key={this.state.answers2.AnswerId} id={this.state.licenseTypeID} stateCode={this.state.selectedUSState2} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    fetchQuestionsByLicenseType(id) {
        //these are the id's of the psychological associate sub nav
        let openSubHeader = (id === "-1" || id === "4" || id === "5" || id === "6" || id === "7")
        this.setState({
            openSubHeader
        })
        //-1 is the id for the 'fake psychological associate"
        if (id !== "-1") {
            fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/jurisdictionquestions`)
                .then(function (response) {
                    return response.json();
                })
                .then((data) => {
                    // console.log(data);
                    const filteredJurisdictions = data.filter((s) => {
                        if (s.questionIds.length > 0) {
                            return s.jurisdictionName
                        }
                    })
                    this.setState({
                        data: data,
                        loaded: true,
                        jurisdictions: filteredJurisdictions
                    })
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    filterLicenseType(e) {
        this.setState({
            licenseTypeID: e.target.id
        })
        let id = e.target.id;
        this.fetchQuestionsByLicenseType(id);
    }

    highlightApplicableQuestions = (stateCode) => {
        const filteredStates = this.state.data.filter(row => stateCode === row.jurisdiction);
        this.setState({
            filteredStates
            // highlight: true
        });
    }

    toggleLicenseTypeColor = (id) => {
        console.log("LincenseTypeId", id)
        this.setState({
            activeIndex: +id,
        })
    }

    handleFirstSelectUSState = (stateCode) => {
        this.clearFirstStateSelection();

        this.setState({
            selectedUSState: stateCode
        });
        this.fetchAnswersByJurisdiction(this.state.licenseTypeID, stateCode);
        // this.highlightApplicableQuestions(stateCode);
    }

    clearFirstStateSelection = () => {
        this.setState({
            selectedUSState: null,
            data: null,
            answers1: [],
            answerOneLoaded: false
        });
    }

    clearSecondStateSelection = () => {
        this.setState({
            selectedUSState2: null,
            data: null,
            answers2: [],
            answerTwoLoaded: false
        });
    }    

    handleSecondSelectUSState = (stateCode) => {
        this.clearSecondStateSelection();

        this.setState({
            selectedUSState2: stateCode
        });
        this.fetchSecondAnswersByJurisdiction(this.state.licenseTypeID, stateCode);
        // this.highlightApplicableQuestions(stateCode);
    }

    fetchAnswersByJurisdiction(id, stateCode) {
        console.log("fetchAnswersByJurisdiction", `${process.env.REACT_APP_API_URL}/api/licensing/${id}/JurisdictionAnswersTopLevel/${stateCode}`);
        fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/JurisdictionAnswersTopLevel/${stateCode}`)
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                // console.log(data.Answers);
                this.setState({
                    data: data,
                    answers1: data.Answers,
                    answerOneLoaded: true
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    fetchSecondAnswersByJurisdiction(id, stateCode) {
        console.log("fetchSecondAnswersByJurisdiction", `${process.env.REACT_APP_API_URL}/api/licensing/${id}/JurisdictionAnswersTopLevel/${stateCode}`);
        fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/JurisdictionAnswersTopLevel/${stateCode}`)
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                // console.log(data.Answers);
                this.setState({
                    data: data,
                    answers2: data.Answers,
                    answerTwoLoaded: true
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    storeFirstDropdownLabel = (label) => {
        // console.log(label);
        this.setState({
            answerColumnOneLabel: label
        })

    }
    storeSecondDropdownLabel = (label) => {
        this.setState({
            answerColumnTwoLabel: label
        })
    }
}




export default DetailView;


// WEBPACK FOOTER //
// ./src/components/DetailView.js